import Phaser from 'phaser'
import Config from '../launch/config'

export default class Nebula extends Phaser.GameObjects.TileSprite {
    constructor(options) {
        const key = `nebula${Phaser.Math.Between(1, 12)}`
        const src = Config.scene.textures.list[key].source[0]
        const scene = Config.scene
        const width = src.width
        const height = src.height
        const x = 0
        const y = 0

        super(scene, x, y, width, height, key)

        this.width = width
        this.height = height
        this.setDepth(0)
        this.setOrigin(0.5)
        this.setScale(2.5)
        this.setAlpha(0.34)
        this.setStart(options.startOnScreen)
        this[Config.namespace] = {type: 'nebula'}

        Config.scene.add.existing(this)
    }

    setStart(startOnScreen) {
        const {boardHeight, boardWidth} = Config.boardSizes[Config.boardSize]

        this.isReversed = Config.chance.bool()
        this.angle = Phaser.Math.Between(0, 360)
        this.speed = Phaser.Math.FloatBetween(0.05, 0.5)

        if (startOnScreen) {
            this.x = Phaser.Math.Between(0, boardWidth)
            this.y = Phaser.Math.Between(0, boardHeight)
            return
        }

        if (this.isReversed) {
            this.x = boardWidth + Config.boardPadding + this.width
        } else {
            this.x = 0 - this.width /// * 3
        }

        this.y = Phaser.Math.Between(
            -Config.boardPadding,
            boardHeight - this.height
        )
    }

    preUpdate(time, delta) {
        if (
            (!this.isReversed &&
                this.x >
                    Config.boardSizes[Config.boardSize].boardWidth +
                        Config.boardPadding +
                        this.width) ||
            (this.isReversed && this.x < 0 - Config.boardPadding - this.width)
        ) {
            this.setStart()
        } else {
            this.x = this.isReversed
                ? (this.x -= this.speed)
                : (this.x += this.speed)
        }
    }
}
